import { Routes } from '@angular/router';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from './app/guards/auth.guard';
import { RedirectGuard } from './app/guards/redirect.guard';
import { EmptyComponent } from './app/pages/public/empty/empty.component';
import { HelpComponent } from './app/pages/help/help.component';
import { DesktopSsoComponent } from './app/pages/public/desktop-sso/desktop-sso.component';
import { PublicGuard } from './app/guards/public.guard';
import { permissionsGuard } from './app/guards/permissions.guard';
import { lightAccountGuard } from './app/guards/light-account.guard';

export const appRoutes: Routes = [
    {
        path: '',
        canActivate: [RedirectGuard],
        pathMatch: 'full',
        component: EmptyComponent
    },
    {
        path: '',
        loadComponent: () => import('./app/layout/component/app.layout').then(m => m.AppLayout),
        // Comptes légers (pages d'inscription personnalisées) : jamais de BO
        // classique, renvoi vers la marketplace des pages perso.
        canActivate: [lightAccountGuard],
        // Matrice des droits fraîche + pages refusées sans leur droit
        // (voir services/permissions/route-permissions.ts).
        canActivateChild: [permissionsGuard],
        children: [
            {path: '', loadChildren: () => import('./app/pages/private/private.routes'), canActivate: [AuthGuard] },
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'aide', component: HelpComponent, data: { title: 'Aide & Support' } },
    // Pont SSO desktop : page ouverte dans le navigateur système, qui renvoie
    // l'utilisateur vers l'app Tauri via le schéma custom `narratheque://`.
    // Hors guards (jamais accédée comme une page "normale").
    { path: 'desktop-sso', component: DesktopSsoComponent },
    // Site vitrine multi-versions (/scrap/io, /scrap/ca, /scrap/henrri) —
    // public, hors AppLayout ET hors PublicGuard (ce dernier redirige les
    // utilisateurs connectés vers /chat, ce qui casserait la preview chef).
    // NB : pathMatch:'full' obligatoire sur la redirection — en 'prefix'
    // (défaut) elle capte aussi /scrap/io et la nav part en /login.
    { path: 'scrap', redirectTo: 'scrap/default', pathMatch: 'full' },
    { path: 'scrap/:slug', loadComponent: () => import('./app/pages/public/scrap/scrap.page').then(m => m.ScrapPage) },
    // Pages d'inscription personnalisées (/inscription/{slug}?from=<page perso>) :
    // hors AppLayout et hors PublicGuard (un visiteur déjà connecté y est
    // invité à continuer au lieu d'être renvoyé vers /chat).
    { path: 'inscription/:slug', loadComponent: () => import('./app/pages/public/signup/signup.page').then(m => m.SignupPage), data: { title: 'Créer un compte' } },
    // Marketplace des pages perso : interface des comptes légers (hors AppLayout).
    { path: 'marketplace', loadComponent: () => import('./app/pages/marketplace/marketplace.page').then(m => m.MarketplacePage), canActivate: [AuthGuard], data: { title: 'Marketplace' } },
    // Module web-agents PUBLIC (invité, sans AppLayout, hors guards boclient).
    { path: 'agents', loadChildren: () => import('./app/webagents-public/webagents.routes') },
    { path: '', loadChildren: () => import('./app/pages/public/public.routes'), canActivate: [PublicGuard] },
    { path: '**', redirectTo: '/notfound' }
];
